module.exports = __webpack_public_path__ + "static/media/diversity.b7f7ef83.jpg";